import i18n from 'i18next'
import PropTypes from 'prop-types'
import Backend from 'i18next-xhr-backend'
// import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next, useTranslation } from 'react-i18next'
import React from 'react'
import { IconButton, Menu, MenuItem } from '@material-ui/core'
import { Language } from '@material-ui/icons'

const supportLang = {
    // key: display_value
    en: 'English',
    tw: '繁體中文',
    zh: '简体中文',
    vi: 'Tiếng Việt',
    th: 'Thai',
    id: '印尼文',
    es: '西班牙文',
    pt: '葡萄牙文',
}

const enabledLang = ['en', 'zh']

/** 預設語系 */
const defaultLang = 'zh'
/** 取得儲存的語系 */
let setLang = localStorage.getItem('langs')
if (!setLang) {
    setLang = defaultLang
    localStorage.setItem('langs',setLang)
}

i18n
    // load translation using xhr -> see /public/locales
    // learn more: https://github.com/i18next/i18next-xhr-backend
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    // .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        lng: setLang,
        fallbackLng: 'en',
        preload: Object.keys(supportLang),
        debug: false,

        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        backend: {
            // for all available options read the backend's repository readme file
            loadPath: '/locales/{{lng}}/{{ns}}.json',
        },
    })

export default i18n

/** 判斷是否為星城 */
let isXin = false

/** 取得 Response Headers */
/* eslint-disable no-restricted-globals */
var xhr = new XMLHttpRequest();
xhr.open('GET', location.origin, true);

xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
        // 取得特定的響應標頭
        var site = xhr.getResponseHeader('Site');
        if (site === 'XIN') {
            isXin = true
            const setLang = localStorage.getItem('langs')
            if (setLang !== 'tw') {
                localStorage.setItem('langs', 'tw')
                window.location.reload()
            }
        }
    }
};

xhr.send();

export function LanguageSelector(props) {
    const { i18n } = useTranslation()

    const [anchorEl, setAnchorEl] = React.useState(null)

    const iconStyle = {
        color: '#FFF',
    }

    function handleClick(event) {
        setAnchorEl(event.currentTarget)
    }

    function handleChoose(option) {
        localStorage.setItem('langs',option)
        // i18n.changeLanguage(option)
        handleClose()
        window.location.reload()
    }

    function handleClose() {
        setAnchorEl(null)
    }

    return !isXin ? (
        <div>
            <IconButton aria-label="language" aria-controls="long-menu" aria-haspopup="true" onClick={handleClick} style={iconStyle} {...props.icon}>
                <Language />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                keepMounted
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                getContentAnchorEl={null}
                open={Boolean(anchorEl)}
                onClose={handleClose}>
                {Object.keys(supportLang).map(
                    (lanKey, _idx) =>
                        enabledLang.find((lang) => lang === lanKey) && (
                            <MenuItem
                                key={lanKey}
                                onClick={() => {
                                    handleChoose(lanKey)
                                }}
                                selected={lanKey === i18n.language}>
                                {supportLang[lanKey]}
                            </MenuItem>
                        )
                )}
            </Menu>
        </div>
    ) : ''
}

LanguageSelector.propTypes = {
    icon: PropTypes.object,
}
